<template>
  <div class="patient-card">
    <div class="information">
      <div class="header">
        <h3>{{ patient.firstName }} {{ patient.lastName }}</h3>
        <div class="details">
          <img
            v-if="!patient.profilePicture"
            src="@/assets/images/nophoto.png"
            :alt="`Profile picture of ${patient.firstName}`"
          />
          <img
            v-else
            :src="patient.profilePicture.blobUri"
            :alt="`Profile picture of ${patient.firstName}`"
          />

          <div>
            <span class="pink--text" v-if="!later">
              {{ visit.dateTime | moment("HH:mm") }}
            </span>
            <span class="pink--text" style="font-size: 19px" v-else>
              {{ visit.dateTime | moment("DD MMM") }}
              {{ visit.dateTime | moment("HH:mm") }}
            </span>
            <p>{{ $t("general.patient.crib") }}: {{ patient.crib }}</p>
          </div>
        </div>
      </div>
      <div class="extra">
        <p v-if="visit.user.nickName && visit.user.nickName.length > 0">
          {{ $t("dash.visit.planned-by") }}
          <strong>{{ visit.user.nickName }}</strong>
        </p>

        <div v-if="visit.extra">
          <h4 class="pink--text">
            {{ $t("dash.visit.extra") }}
          </h4>
          <p>{{ visit.extra }}</p>
        </div>
        <div v-if="visit.remark">
          <h4 class="pink--text">
            {{ $t("dash.visit.remark") }} <a href="#" v-if="deepl && !translated" @click.prevent="translate">({{ $t("dash.visit.translate") }})</a> <a href="#" v-if="translated" @click.prevent="translated=false;">({{ $t("dash.visit.original") }})</a>
          </h4>
          <p v-if="!translated">{{ visit.remark }}</p>
          <p v-if="translated">{{translation}}</p>
        </div>

        <div v-if="visit.message">
          <h4 class="pink--text">{{ $t("dash.visit.message-sent") }}</h4>
          <p class="message">
            "{{ visit.message.substring(0, 200) }} <template v-if="visit.message.length > 200">(...)</template>"
            <span class="read-confirmation">
              ({{
                visit.messageRead
                  ? $t("dash.visit.read")
                  : $t("dash.visit.not-read")
              }})
              <Button
                v-on:click-prevent="doSomething()"
                v-if="visit.message.length > 200"
                margin="1rem 0"
                shadow="true"
                @click.native="$modal.show(`visit-modal${patient.id}`)"
              >
                {{ $t("dash.visit.readFullMessage") }}
              </Button>
            </span>
          </p>
        </div>
      </div>

      <Button
        v-if="($store.getters.user.role === 'a' || $store.getters.user.role === 'n') && !visit.message"
        :title="$t('dash.visit.action-send')"
        shadow="true"
        @click.native="$modal.show(`visit-modal${patient.id}`)"
        margin="1rem 0"
        width="100%"
      ></Button>
    </div>
    <div class="todo">
      <div class="header">
        <h3>{{ $t("dash.visit.planned.activities") }}</h3>
      </div>
      <ul class="tasks">
        <li
          v-for="task in visit.activities"
          :key="task.id"
          :class="{ done: task.finished }"
        >
          <div class="content">
            <span
              class="label"
              @click="
                toggleActivity(task);
              "
              >{{ task.label }}</span
            >
            <span
              v-if="$store.getters.user.role === 'a'  || $store.getters.user.role === 'n'"
              class="delete"
              @click="deleteActivity(task.id)">X</span>
          </div>
        </li>
        <li>
          <v-select
            v-if="$store.getters.user.role === 'a' || $store.getters.user.role === 'n'"
            ref="selectActivity"
            :options="options"
            @input="setSelected"
            taggable
            :select-on-key-codes="[188, 13]"
          ></v-select>
        </li>
      </ul>
    </div>
    <VisitModal
      :personName="patient.firstName"
      :personId="patient.id"
      :visit="visit"
      @confirmed="
        event => {
          visit.nurseId = event.nurseId;
          visit.message = event.message;
        }
      "
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { consoleLog } from "../helpers";
import {neoparentActivities, neoparentPosts, neoparentVisits} from "@/api";
import neoparentVisit from "@/components/NeoparentVisit.vue";

export default {
  name: "VisitCard",
  components: {
    vSelect
  },
  data() {
    return {
      deepl: false,
      translated: false,
      translation: null,
      options: Object.values(this.$t("dash.visit.planned.options"))
    };
  },
  props: {
    patient: { required: true },
    visit: { required: true },
    later: { type: Boolean }
  },
  mounted() {
    this.$root.$nextTick(() => {
      this.deepl = this.$store.getters.user.hospital.hasDeepl;
    })
  },
  methods: {
    doSomething() {
      console.log("Did something")
    },
    async translate() {
      if (!this.translation) {
        const res = await neoparentVisits.translate(this.visit.id);
        this.translation = res.data.translation;
        this.translated = true;
      }
    },
    async toggleActivity(task) {
      if ( (this.$store.getters.user.role === 'a' || this.$store.getters.user.role === 'n' ) && task){
        await neoparentActivities.toggleActivity(task.id)
          .then(() => {
            task.finished = !task.finished
          });
      }

  /*    await axios.post(
        `${this.$backendRoot}/patients/${
          this.$session.get("patient").id
        }/visit/activity/${id}/toggle`,
        {
          token: this.$session.get("admin-token")
        }
      );*/
    },
    async deleteActivity(id) {
      await neoparentActivities.deleteActivity(id)
        .then(() => {
          this.visit.activities = this.visit.activities.filter(
            a => a?.id !== id
          );
      /*      await axios
              .post(
                `${this.$backendRoot}/patients/${
                  this.$session.get("patient").id
                }/visit/activity/${id}/delete`,
                {
                  token: this.$session.get("admin-token")
                }
              )
              .then(res => {
                this.visit.activities = this.visit.activities.filter(
                  a => a.id !== id
                );*/
        });
    },
    async setSelected(value) {
      if (value) {
        const data = {
          visitId: this.visit?.id,
          patientId: this.visit.patient?.id,
          label: value
        }

        await neoparentActivities.addActivity(data)
          .then(res => {
            consoleLog(res);
            if (!this.visit.activities){
              this.visit.activities = []
            }
            this.visit.activities.push(res.data.activity);
            this.$refs.selectActivity.clearSelection();
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.patient-card {
  margin: 0 auto;
  height: 100%;
  width: 100%;
  max-width: 35rem;
  border: 1px solid #00a9b3;
  border-radius: 5px;
  text-align: left;

  display: flex;
  align-items: flex-start;

  .details {
    display: flex;
    margin: 1rem 0;

    * {
      margin: 0;
    }

    div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      margin-left: 1rem;

      span {
        font-weight: bold;
        font-size: 36px;
        line-height: 42px;
      }
    }
  }

  .information {
    width: 50%;
    height: 100%;
    border-right: 1px dashed #8a8a8a;
    padding: 24px;

    .extra {
      * {
        margin: 0.5rem 0;
      }
    }
  }

  .header {
    h3 {
      margin: 0;
    }

    .information {
      padding: 0 1rem;
      display: flex;
      align-items: center;

      h3,
      p {
        margin: 0;
        margin-right: 1rem;
      }
    }
  }

  img {
    max-width: 25%;
    margin: 0;
  }

  .todo {
    width: 50%;
    height: 100%;
    padding: 24px;

    .tasks {
      list-style-type: none;

      li {
        word-break: break-all;
        display: list-item;
        margin-left: 1rem;
        cursor: pointer;
        user-select: none;
        padding: 0.3rem 0;

        .content {
          width: 100%;
          display: inline-flex;
          justify-content: space-between;

          & .delete {
            font-weight: bold;
          }
        }

        &.done .label {
          opacity: 0.5;
          text-decoration: line-through;
        }

        &::before {
          content: ">";
          color: #e05484;
          font-weight: bold;
          display: inline-block;
          width: 1rem;
          margin-left: -1rem;
        }

        &.add {
          display: flex;
          align-items: center;
          margin-top: 1rem;

          .v-select {
            width: 90%;
          }

          &::before {
            content: "+";
          }
        }
      }
    }
  }

  @media (max-width: 40rem) {
    width: 100%;
    flex-direction: column;

    .information {
      width: 100%;
      border: 0;
      border-bottom: 1px dashed #8a8a8a;
    }

    .todo {
      width: 100%;
    }
  }
}
</style>
